"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = Menu;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var _RecursiveMenu = require("../RecursiveMenu");
function Menu(_ref) {
  let {
    activeLanguage,
    catalog,
    brands,
    isLoggedIn,
    languages,
    links,
    onLanguageChange,
    onLinkClick,
    onLogout,
    onModalClose,
    openNextLevel,
    text,
    className
  } = _ref;
  const handleLanguageChange = language => e => {
    e.preventDefault();
    onLanguageChange(language);
    onModalClose(e);
  };
  const handleLogoutClick = e => {
    e.preventDefault();
    onLogout();
    onModalClose(e);
  };
  const areProductsSpecified = products => !!products && Array.isArray(products) && products.length > 0;
  const rootClassName = (0, _classnames.default)('cds-ModalMenu-Wrapper', className);
  return /*#__PURE__*/_react.default.createElement("nav", {
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "cds-ModalMenu-Main"
  }, areProductsSpecified(catalog) && /*#__PURE__*/_react.default.createElement("li", {
    className: "cds-ModalMenu-Item--Main"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "cds-ModalMenu-Link--Main cds-ModalMenu-Link--Arrow",
    href: "#",
    onClick: openNextLevel(text.home, catalog, undefined, text.catalog, _RecursiveMenu.MENU_CATEGORY_ID.catalog)
  }, text.catalog, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-ModalMenu-ArrowIcon",
    name: _Icon.ICON_NAME.arrowRight
  }))), areProductsSpecified(brands) && /*#__PURE__*/_react.default.createElement("li", {
    className: "cds-ModalMenu-Item--Main"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "cds-ModalMenu-Link--Main cds-ModalMenu-Link--Arrow",
    href: "#",
    onClick: openNextLevel(text.home, brands, undefined, text.brands, _RecursiveMenu.MENU_CATEGORY_ID.brands)
  }, text.brands, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-ModalMenu-ArrowIcon",
    name: _Icon.ICON_NAME.arrowRight
  })))), Array.isArray(links) && links.map((linkGroup, index) => /*#__PURE__*/_react.default.createElement("ul", {
    className: "cds-ModalMenu cds-List--Border",
    key: index
  }, Array.isArray(linkGroup) && linkGroup.map(link => /*#__PURE__*/_react.default.createElement("li", {
    className: "cds-ModalMenu-Item",
    key: link.title
  }, link.children?.length ? /*#__PURE__*/_react.default.createElement("a", {
    className: "cds-ModalMenu-Link cds-ModalMenu-Link--Arrow",
    href: "#",
    onClick: openNextLevel(text.home, link.children, undefined, link.title)
  }, link.title, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-ModalMenu-ArrowIcon",
    name: _Icon.ICON_NAME.arrowRight
  })) : /*#__PURE__*/_react.default.createElement("a", {
    className: "cds-ModalMenu-Link",
    href: link.href,
    onClick: onLinkClick(link.href)
  }, link.title))))), /*#__PURE__*/_react.default.createElement("ul", {
    className: "cds-ModalMenu"
  }, languages && languages.map(language => {
    if (activeLanguage === language.code) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "cds-ModalMenu-Item",
      key: language.code
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "cds-ModalMenu-Link",
      href: "#",
      onClick: handleLanguageChange(language.code)
    }, language.label));
  }), isLoggedIn && /*#__PURE__*/_react.default.createElement("li", {
    className: "cds-ModalMenu-Item"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "cds-ButtonLink cds-ModalMenu-Link",
    onClick: handleLogoutClick
  }, text.logout))));
}
//# sourceMappingURL=Menu.js.map